export function take<T>(generator: Generator<T>, amountToTake: number): T[] {
  const taken: T[] = [];

  for (let i = 0; i < amountToTake; i++) {
    const { done, value } = generator.next();

    if (done) break;

    taken.push(value);
  }

  return taken;
}
